export const RADIO_BUTTONS = "radio_buttons";
export const SELECT = "select";
export const CHECKBOXES = "checkboxes";

export type ElemType = typeof RADIO_BUTTONS | typeof SELECT | typeof CHECKBOXES;

export interface TargetField {
  elemId: string;
  description: string;
  elemType: ElemType;
  expectedValues: string[];
}

export interface ArchiveDetail {
  archivedAtUnixTime: number;
  archivedBy: string;
}

export interface Condition {
  id: string;
  match: {
    const: string;
  };
}

export const GROUP_PRINCIPAL = "groupPrincipal";

export type PrincipalType = typeof GROUP_PRINCIPAL;

export interface Principal {
  type: PrincipalType;
  id: string;
}

export interface Assignment {
  assignee: Principal;
}

export interface AssignmentRule {
  conditions: Condition[];
  assignments: Assignment[];
}

export interface ChangeInfo {
  createdAt: string;
  updatedAt: string;
}

export interface ProcedureAssignmentSettingRuleSet
  extends ArchiveDetail,
    ChangeInfo {
  readonly id: string;
  readonly tenantId: string;
  readonly name: string;
  readonly description: string;
  readonly version: number;
  readonly targetFields: TargetField[];
  readonly rules: AssignmentRule[];
}

export interface AssignmentSettingRuleSetInput {
  tenantId: string;
  name: string;
  description: string;
  targetFields: TargetField[];
  rules: AssignmentRule[];
}

export interface ValidationResult {
  isValid: boolean;
  errorMessages: string[];
}

export const validateAssignmentSettingRuleSet = (
  input: Pick<
    AssignmentSettingRuleSetInput,
    "name" | "description" | "targetFields" | "rules"
  >,
): ValidationResult => {
  const errorMessages: string[] = [];

  if (!input.name.trim()) {
    errorMessages.push("名前は必須です。");
  }

  if (!input.description.trim()) {
    errorMessages.push("説明は必須です。");
  }

  if (!input.targetFields.length) {
    errorMessages.push("対象フィールドを1つ以上選択してください。");
  }

  if (!input.rules.length) {
    errorMessages.push("振り分けルールを1つ以上設定してください。");
  }

  return {
    isValid: errorMessages.length === 0,
    errorMessages,
  };
};
